<template>
    <div class="version-upgrade">
        版本升级
    </div>
</template>

<script>
    export default {
        name: "version-upgrade"
    }
</script>

<style scoped>

</style>